<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("unit.title", 2) }}
        </label>
        <facilities-paginated
          :value="facilitiesFilter"
          :multiple="true"
          @input="handleSelectUnit($event)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("dmp.panel") }}
        </label>
        <v-select
          :value="panelFilter"
          :options="panelOptions"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:panelFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.start_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="startDatetime"
          @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.end_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="endDatetime"
          @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("dmp.eventDefinition", 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="eventDefinitionOptionsFilter"
          :options="eventDefinitionOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="handleEventDefinitions"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("dmp.eventType", 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="description"
          :value="eventCodeFilter"
          :options="eventTypes"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.code"
          @input="(val) => $emit('update:eventCodeFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.alarm_type_sbo") }}</label>
        <v-select
          :value="typeAlarmFilter"
          :options="typeAlarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("dmp.isRecovered", 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="recoveredFilter"
            :options="[
            { label: $t('dmp.recovered_yes'), value: true },
            { label: $t('dmp.recovered_no'), value: false },
          ]"
          :multiple="false"
          class="w-100"
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:recoveredFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import popperHelper from "@/libs/popper-helper";
import FacilitiesPaginated from "@/components/FacilitiesPaginated.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
    FacilitiesPaginated
  },
  props: {
    eventDefinitionOptions: {
      type: Array,
      default: [],
    },
    eventDefinitionOptionsFilter: {
      default: null,
    },
    eventCodeFilter: {
      default: null,
    },
    panelOptions: {
      type: Array,
    },
    panelFilter: {
      default: null,
    },
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    },
    typeAlarmOptions: {
      type: Array,
    },
    typeAlarmFilter: {
      default: null,
    },
    recoveredFilter: {
      type: Boolean,
      default: null,
    },
    facilitiesFilter: {
      default: null,
    },
  },
  data() {
    return {
      localSearchQuery: this.searchQuery,
    };
  },
  computed: {
    eventTypes() {
      const selectedDefinitions = Array.isArray(this.eventDefinitionOptionsFilter)
        ? this.eventDefinitionOptionsFilter
        : this.eventDefinitionOptionsFilter
          ? [this.eventDefinitionOptionsFilter]
          : [];

      const relatedEvents = this.eventDefinitionOptions
        .filter(option => selectedDefinitions.includes(option.value))
        .flatMap(option => option.related_events || []);

      return Array.from(
        new Map(relatedEvents.map(event => [event.code, event])).values()
      );
    },
  },
  watch: {
    searchQuery(val) {
      this.localSearchQuery = val;
    },
  },
  methods: {
    updateSearchQuery() {
      this.$emit("update:searchQuery", this.localSearchQuery);
    },
    handleSelectUnit(event) {
      // this.data.data = { ...this.data.data, ...event }; //sets new unit to show
      this.$emit('update:facilitiesFilter', event)
    },
    handleEventDefinitions(value) {
      const selectedDefinitions = Array.isArray(value) ? value : value ? [value] : [];
      const validEventCodes = new Set(
        this.eventDefinitionOptions
          .filter(option => selectedDefinitions.includes(option.value))
          .flatMap(option => option.related_events || [])
          .map(event => event.code)
      );
      const selectedEventCodes = Array.isArray(this.eventCodeFilter)
        ? this.eventCodeFilter
        : this.eventCodeFilter
          ? [this.eventCodeFilter]
          : [];

      this.$emit('update:eventDefinitionOptionsFilter', value);
      this.$emit(
        'update:eventCodeFilter',
        selectedEventCodes.filter(code => validEventCodes.has(code))
      );
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
